import React, { useRef, Suspense } from 'react';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';

const QuickNavigationModal = React.lazy(
  () => import('@amzn/aac-quick-navigation-modal'),
);

const SideNavModal: React.VFC = () => {
  const { openModalAppName, setOpenModalAppName } = useConsolidatedNavContext();
  const buttonRef = useRef<HTMLButtonElement>();

  const closeModal = () => {
    setOpenModalAppName('');
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <QuickNavigationModal
        type={openModalAppName}
        isOpen={!!openModalAppName}
        onClose={closeModal}
        toggleEl={buttonRef.current}
        modalElementId="AACChromePortal"
        data-ccx-e2e-id="aac-quick-nav-modal-close"
      />
    </Suspense>
  );
};

export default SideNavModal;
